import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class HeaderScroll {
  constructor() {
    this.header = document.getElementById('site-header');

    if (!this.header || !document.body.classList.contains('tournament-site')) {
      this.header = null;
      return;
    }

    this.header.classList.remove('is-hidden');
    this.trigger = ScrollTrigger.create({
      start: 0,
      end: 'max',
      onUpdate: (self) => {
        this.header.classList.toggle('is-hidden', self.direction === 1 && self.scroll() > this.header.offsetHeight);
      },
    });
  }

  destroy() {
    if (!this.header) {
      return;
    }

    this.trigger.kill();
    this.header.classList.remove('is-hidden');
  }
}
